﻿export class HeartSnippet {

    public static backgroundReplacement($: JQueryStatic): void {


        $('.s-heart').each(function (idx, val) {

            const imageSrc = $(val).find('.s-heart__image--bg-image').attr('src');

            const path = 'url(' + imageSrc + ')';

            $(val).find('.s-heart__shadow-mask').css('background-image', path);

        });
        

        

    }
}